import { render, staticRenderFns } from "./CreateSupplier.vue?vue&type=template&id=32389168"
import script from "./CreateSupplier.vue?vue&type=script&lang=js"
export * from "./CreateSupplier.vue?vue&type=script&lang=js"
import style0 from "./CreateSupplier.vue?vue&type=style&index=0&id=32389168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports